module.exports = __webpack_public_path__ + "img/book2.96a64566.jpg";